import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
    return (
        <section className="pt-32 sm:pt-44 pb-24">
            <div className="container-atelier max-w-xl text-center">
                <p className="eyebrow mb-3">404</p>
                <h1 className="font-serif text-4xl sm:text-5xl leading-tight">Pagina non trovata</h1>
                <p className="mt-4 text-muted-foreground">La pagina che cerchi non esiste più, o non è mai esistita.</p>
                <Button asChild className="mt-7 h-11 px-5"><Link to="/">Torna alla home</Link></Button>
            </div>
        </section>
    );
}
